export const endpoints = {
    configuration: 'configurations',
    cms: 'pages',
    banners: 'banners',

    login: 'customer/login',
    register: 'customer/register',
    logout: 'customer/logout',
    profile: 'customer/profile',
    changePassword: 'customer/change/password',
    resetPassword: 'customer/password/reset',
    updatePassword: 'customer/password/update',
    sendOTP: 'customer/resend/otp',
    verifyOTP: 'customer/verify/otp',
    deactivate: 'customer/deactivate',

    governorates: 'governorates',
    areas: 'areas',
    addresses: 'customer/addresses',
    address: 'address',

    products: 'products',
    productCategories: 'product_categories',

    branches: 'branches',
    workers: 'workers',
    slots: 'slots',
    services: 'services',
    serviceCategories: 'service_categories',
    bookings: 'bookings',
    feedback: 'feedback',
    bookingsIdentifier: 'bookings/identifier',

    purchase: 'product/purchase',
    packages: 'packages',
    orderHistory: 'orders',
    getBookings: 'get_bookings',
    packageDetail: 'customer/package-detail',
    couponsValidate: 'coupons/validate',
    notficationStatus: 'customer/change/notfication_status',
};